/**
 * @owner @Appboy/growth-engineering
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { milestoneChecklistCacheKeys } from "./constants";
import type { MilestoneChecklistApiResponse, MilestoneChecklistRequestParams } from "./types";

export const postMilestoneChecklist = reactQueryMutationAdapter(
  milestoneChecklistCacheKeys,
  (params: MilestoneChecklistRequestParams): Promise<MilestoneChecklistApiResponse> => {
    return fetch("/milestone_checklist", "POST", params);
  }
);
